class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("#predictive-search");

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.addEventListener("click", this.onChange.bind(this));
    var keyupBind = this.onKeyup.bind(this);
    var keydownBind = this.onKeydown.bind(this);
    this.addEventListener("keyup", keyupBind);
    this.addEventListener("keydown", keydownBind);

    this.parentElement
      .querySelectorAll(".all_categories_dropdown .list")
      .forEach((item) =>
        item.addEventListener("click", this.onDropdownClick.bind(this))
      );

    if (this.parentElement.querySelector(".header_all_categories > details")) {
      var allCategoriesElem = this.parentElement.querySelector(
        ".header_all_categories > details"
      );
      allCategoriesElem.addEventListener("focusout", function (event) {
        if (
          !event.relatedTarget ||
          !event.relatedTarget.closest(".header_all_categories")
        ) {
          allCategoriesElem.removeAttribute("open");
        }
      });

      allCategoriesElem.addEventListener("keyup", function (event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;
        allCategoriesElem.removeAttribute("open");
        allCategoriesElem.querySelector("summary").focus();
      });
    }
  }

  onDropdownClick(event) {
    var get_html = event.currentTarget.innerHTML;
    var get_handle = event.currentTarget.dataset.handle;

    event.currentTarget
      .closest("details")
      .querySelector(".categories_name").innerHTML = get_html;
    this.querySelector('input[name="target"]').value = get_handle;
    event.currentTarget.closest("details").removeAttribute("open");
    this.querySelector("#predictive-search").style.display = "none";
  }
  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    var categories_name = this.querySelector('input[name="target"]').value;

    if (categories_name == "all-categories") {
      var url = `${window.routes.predictive_search_url}?q=${searchTerm}&resources[type]=query,product,collection,page,article&section_id=predictive-search`;
    } else {
      var url = `/collections/${categories_name}?_pos=1&_psq=${searchTerm}&_ss=e&_v=1.0`;
    }

    fetch(`${url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        if (categories_name == "all-categories") {
          var resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-predictive-search").innerHTML;
        } else {
          var resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(
              "#shopify-section-predictive-search-collection"
            ).innerHTML;
        }
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    // this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.predictiveSearchResults.style.display = "block";
    trapFocus(this.input.closest("form"), this.input);
    var allElements = this.querySelectorAll("li");
    for (let i = 0; i < allElements.length; i++) {
      allElements[i].dataset.forloopIndex = i;
    }
  }

  close() {
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.style.display = "none";
    removeTrapFocus(this.input);
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onKeyup(event) {
    event.preventDefault();
    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
      case "Escape":
        var keyupBind = this.onKeyup.bind(this);
        var keydownBind = this.onKeydown.bind(this);
        this.close();
        this.removeEventListener("keyup", keyupBind);
        this.removeEventListener("keydown", keydownBind);
        break;
    }
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight -
      document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    const moveUp = direction === "up";
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll("li");
    let firstElement = this.querySelector("li");
    var currentIndex = "nothing selected yet";
    if (!!selectedElement) {
      currentIndex = selectedElement.dataset.forloopIndex;
    }

    var activeElement = this.querySelector(`li[data-forloop-index="0"]`);

    if (moveUp) {
      let prevIndex = parseInt(currentIndex) - 1;
      if (!!this.querySelector(`li[data-forloop-index="${prevIndex}"]`)) {
        activeElement = this.querySelector(
          `li[data-forloop-index="${prevIndex}"]`
        );
      } else {
        activeElement = this.querySelector(
          `li[data-forloop-index="${allElements.length - 1}"]`
        );
      }
    } else {
      let nextIndex = parseInt(currentIndex) + 1;
      if (!!this.querySelector(`li[data-forloop-index="${nextIndex}"]`)) {
        activeElement = this.querySelector(
          `li[data-forloop-index="${nextIndex}"]`
        );
      } else {
        activeElement = this.querySelector(`li[data-forloop-index="0"]`);
      }
    }

    activeElement.setAttribute("aria-selected", true);
    if (selectedElement) selectedElement.setAttribute("aria-selected", false);
    activeElement.focus();

    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector(
      '[aria-selected="true"] a, [aria-selected="true"] button'
    );

    if (selectedProduct) selectedProduct.click();
  }
}

customElements.define("predictive-search", PredictiveSearch);

/* OPEN CLOSE SEARCH */
function searchFadeIn(elem) {
  elem.style.display = "block";
  elem.style.opacity = 0;
  setTimeout(function () {
    elem.style.opacity = 1;
  }, 100);
}

function searchFadeOut(elem) {
  elem.style.opacity = "0";
  setTimeout(function () {
    elem.style.display = "none";
  }, 400);
}

var elemPredictiveSearchWrapper = document.querySelector(
  ".predictive-search-wrapper"
);

function closeSearchModal() {
  elemPredictiveSearchWrapper.classList.remove("active_search-bar");
  searchFadeOut(elemPredictiveSearchWrapper);

  removeTrapFocus(document.querySelector(".header__icon--search"));
  setTimeout(function () {
    if (document.querySelectorAll(".hero-slider.flickity-enabled").length > 0) {
      document
        .querySelector(".hero-slider.flickity-enabled")
        .classList.remove("z_index0");
    }
  }, 400);
}

// submit the form on click of the search icon
document
  .querySelector("predictive-search form")
  .addEventListener("submit", (e) => {
    var categories_name = document.querySelector(
      'predictive-search input[name="target"]'
    ).value;
    if (categories_name == "all-categories") {
      return;
    } else {
      e.preventDefault();
      const searchTerm = document
        .querySelector('predictive-search input[type="search"]')
        .value.trim();
      var url = `/collections/${categories_name}?_pos=1&_psq=${searchTerm}&_ss=e&_v=1.0`;
      window.location.href = url;
      return;
    }
  });

// close search when clicked outside of the search box
document.addEventListener("click", function (event) {
  if (
    !event.target.closest("header") &&
    !event.target.closest("predictive-search") &&
    !event.target.closest("select")
  ) {
    closeSearchModal();
  }
});
